define('shared/remote/payment/redemption/redeem',[
    '$',
    'shared/lib/RSVP', 
    'shared/my/cmus',
    'shared/my/identity',
    'shared/page/market',
    'shared/page/partner',
    'shared/page/apiVersion',
    'shared/page/eTag',
    'shared/remote/offer/get',
    'shared/lib/console',
    '..//ajax'
],
function (
    $, 
    RSVP, 
    getCMus, 
    getIdentity, 
    getMarket, 
    getPartner, 
    getAPIVersion, 
    getETag,
    getOffer, 
    console,
    ajax
) {
    'use strict';

    return function(options){
        var rCode = options.rCode;
        var offers = options.offers;
        var apiVersion;

        if(!rCode){
            return RSVP.resolve();
        }

        return RSVP
            .resolve()
            .then(function(){
                return getAPIVersion();
            })
            .then(function(value){
                apiVersion = value;
                if(!offers){
                    if (apiVersion !== 'new-house') {
                        return getOffer({redemptionCode: rCode})
                            .then(function(offer){
                                return [offer.Id.toString()];
                            });
                    }
                }
                else {
                    return offers;
                }
            })
            .then(function(normalizedOffers){
                offers = normalizedOffers;
            })
            .then(function(){
                return RSVP.all([getMarket(), getPartner(), getIdentity(), getCMus(), getETag()]);
            })
            .then(function(environment){
                var marketCode = environment[0];
                var partnerCode = environment[1];
                var memberId = environment[2];
                var cmus = environment[3];
                var eTag = environment[4];

                if (apiVersion === 'new-house') {
                    return ajax({
                        url: '/1/api/commerce-gateway/order/redeem',
                        type: 'POST',
                        data: {
                            'PurchaseInfo': {
                                'Country': marketCode,
                                'Partner': partnerCode,
                                'Etag': eTag,
                                'Channel': 'online'
                            },
                            'Redemption': rCode
                        }
                    });
                }
                else {
                    if (!offers || offers.length <= 0) {
                        return RSVP.reject('Cannot get offer for rCode ' + rCode + ' ');
                    }
                    return new RSVP.Promise(function(resolve, reject) {
                        $.ajax({
                            url: '/services/commerce-v4/offermanager/BuyWithRedemptionCode',
                            type: 'POST',
                            data: {
                                'cmus': cmus,
                                'purchaseInfo.MemberId': memberId,
                                'purchaseInfo.OfferId': offers[0],
                                'purchaseInfo.RedemptionCode': rCode,
                                'purchaseInfo.MarketCode': marketCode,
                                'purchaseInfo.PartnerCode': partnerCode
                            }
                        })
                        .then(
                            function (data) {
                                console.log('BuyWithRedemptionCode received data:', data);

                                if(!data || !data.Success || !data.Result){
                                    reject('Failed to consume redemption code due to server error, please try again later');
                                }
                                else{
                                    resolve(data.Result);
                                }
                            },
                            function (reason) {
                                var err = reason || new Error('Failed to consume redemption code due to connection issue, please try again later');
                                reject(err);
                            }
                        );
                    });
                }
            });
    };
});
